import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { adminLogin } from "@/api";
import { FadeIn, LotusMark } from "@/components/Reveal";

const formatError = (e) => {
  const detail = e?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d.msg || "").join(" ");
  return "Something went wrong. Please try again.";
};

const AdminLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const data = await adminLogin(email, password);
      localStorage.setItem("vaiyra_admin_token", data.token);
      localStorage.setItem("vaiyra_admin_role", data.role || "admin");
      navigate("/admin");
    } catch (err) {
      setError(formatError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="pt-32 pb-24 px-6 min-h-screen">
      <FadeIn className="max-w-md mx-auto">
        <div className="text-center">
          <LotusMark className="w-9 h-9 text-gold mx-auto" />
          <h1 className="mt-5 font-display text-4xl text-maroon-deep">The Atelier Door</h1>
          <p className="mt-2 text-sm text-clay">For the keeper of the collection only.</p>
        </div>
        <form onSubmit={handleSubmit} className="mt-10 bg-ivory-card border border-gold/30 p-8 space-y-6">
          {error && (
            <p data-testid="admin-login-error" className="text-sm text-maroon bg-maroon/5 border border-maroon/20 px-4 py-3">{error}</p>
          )}
          <label className="block">
            <span className="text-[10px] tracking-[0.3em] uppercase text-clay">Email</span>
            <input
              data-testid="admin-email-input"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-2 w-full bg-ivory border border-maroon/20 px-4 py-3.5 text-sm text-maroon-deep focus:outline-none focus:border-gold transition-colors"
              placeholder="admin@vaiyra.in"
            />
          </label>
          <label className="block">
            <span className="text-[10px] tracking-[0.3em] uppercase text-clay">Password</span>
            <input
              data-testid="admin-password-input"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-2 w-full bg-ivory border border-maroon/20 px-4 py-3.5 text-sm text-maroon-deep focus:outline-none focus:border-gold transition-colors"
              placeholder="••••••••"
            />
          </label>
          <button
            type="submit"
            data-testid="admin-login-submit"
            disabled={loading}
            className="w-full bg-maroon text-ivory py-4 text-xs tracking-[0.35em] uppercase hover:bg-maroon-hover transition-colors duration-300 disabled:opacity-60"
          >
            {loading ? "Opening…" : "Enter the Atelier"}
          </button>
        </form>
        <p className="mt-6 text-center">
          <Link to="/" data-testid="admin-login-back-link" className="text-xs tracking-[0.25em] uppercase text-clay hover:text-gold-dark transition-colors">
            Back to the Maison
          </Link>
        </p>
      </FadeIn>
    </div>
  );
};

export default AdminLogin;
